import { css } from 'styled-components';
import {
  CtaWrapper,
  Heading,
  InfoCardRichText,
} from '../../../../components/InfoCard/InfoCard/styles';
import colors from '../../../../helpers/colors';
import spacing from '../../../../helpers/spacing';

export default css`
  && {
    background-color: ${colors.neutral08};
  }
  ${Heading} {
    margin: 0;
    margin-bottom: ${spacing(2)};
  }

  ${InfoCardRichText} {
    margin: 0;
    & > p:not(:first-child) {
      margin-top: ${spacing(2)};
    }
  }

  ${CtaWrapper} {
    padding-top: ${spacing(2)};
  }
`;
